import Axios from 'axios';
import MaterialTable from 'material-table';
import React, {useEffect, useState} from 'react';
import {tableIcons} from '../../styles/tableIcons';
import {tableLocalization} from '../../styles/tableLocalization';
import TableTitle from '../utils/TableTitle';

export function TeacherStudentsTable() {
  const [students, setStudents] = useState([]);

  const columns = [
    {title: 'Email', field: 'email'},
    {title: 'Class', field: 'classroomName'},
    {title: 'Water Readings', field: 'waterReadings', type: 'numeric'},
    {title: 'Water Step', field: 'waterStep', type: 'numeric'},
    {title: 'Electric Readings', field: 'electricReadings', type: 'numeric'},
    {title: 'Electric Step', field: 'electricStep', type: 'numeric'},
    {title: 'Gas Readings', field: 'gasReadings', type: 'numeric'},
    {title: 'Gas Step', field: 'gasStep', type: 'numeric'},
  ];

  useEffect(() => {
    const getStudents = async () => {
      const result = await Axios.get('/api/user/me/students');
      setStudents(result.data);
    };
    getStudents();
  }, []);

  return (
    <MaterialTable
      localization={tableLocalization}
      title={<TableTitle>{'Student Progress (out of 8 steps)'}</TableTitle>}
      columns={columns}
      data={students}
      icons={tableIcons}
      options={{
        // Column drag handles render a role="button" inside each sortable
        // header button (nested interactive controls, WCAG 4.1.2).
        draggable: false,
        actionsColumnIndex: -1,
        pageSize: 100,
      }}
    />
  );
}
